var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ParentCommunicationRecords.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-08c12a27\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ParentCommunicationRecords.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/user/ParentCommunicationRecords.vue
// module id = 1559
// module chunks = 8